import SupplierInfoBox from './SupplierInfoBox'

export default SupplierInfoBox
